export const data = {
  afIntegrations: [
    {
      name: 'AppLovin',
      key: 'applovin_int',
      description: 'Enables Duet to measure the performance of its own marketing campaigns and improve them over time.',
      url: 'https://www.applovin.com/privacy/',
      marketPlace: 'https://hq1.appsflyer.com/partner-marketplace/partner/applovin_int-ad_network',
    },
    {
      name: 'Apple Search Ads',
      key: 'iossearchads_int',
      description: 'Enables Duet to measure the performance of its own marketing campaigns and improve them over time.',
      url: 'https://ads.apple.com/app-store/privacy',
      marketPlace: 'https://hq1.appsflyer.com/partner-marketplace/partner/iossearchads_int-ad_network',
    },
    {
      name: 'Google Ads',
      key: 'googleadwords_int',
      description: 'Enables Duet to measure the performance of its own marketing campaigns and improve them over time.',
      url: 'https://policies.google.com/privacy?hl=en',
      marketPlace: 'https://hq1.appsflyer.com/partner-marketplace/partner/googleadwords_int-ad_network',
    },
    {
      name: 'Google Ads Web',
      key: 'googleads_int',
      description: 'Enables Duet to measure the performance of its own marketing campaigns and improve them over time.',
      url: 'https://policies.google.com/privacy?hl=en',
      marketPlace: 'https://hq1.appsflyer.com/partner-marketplace/partner/googleads_int-ad_network',
    },
    {
      name: 'Liftoff',
      key: 'liftoff_int',
      description: 'Enables Duet to measure the performance of its own marketing campaigns and improve them over time.',
      url: 'https://liftoff.io/privacy-policy/',
      marketPlace: 'https://hq1.appsflyer.com/partner-marketplace/partner/liftoff_int-ad_network',
    },
    {
      name: 'Meta Ads',
      key: 'facebook_int',
      description: 'Enables Duet to measure the performance of its own marketing campaigns and improve them over time.',
      url: 'https://mbasic.facebook.com/privacy/policy/printable/',
      marketPlace: 'https://hq1.appsflyer.com/partner-marketplace/partner/facebook_int-ad_network',
    },
    {
      name: 'Meta Web',
      key: 'metaweb_int',
      description: 'Enables Duet to measure the performance of its own marketing campaigns and improve them over time.',
      url: 'https://mbasic.facebook.com/privacy/policy/printable/',
      marketPlace: 'https://hq1.appsflyer.com/partner-marketplace/partner/metaweb_int-ad_network',
    },
    {
      name: 'Pangle',
      key: 'bytedanceglobal_int',
      description: 'Enables Duet to measure the performance of its own marketing campaigns and improve them over time.',
      url: 'https://www.pangleglobal.com/privacy',
      marketPlace: 'https://hq1.appsflyer.com/partner-marketplace/partner/bytedanceglobal_int-ad_network',
    },
    {
      name: 'Snapchat',
      key: 'snapchat_int',
      description: 'Enables Duet to measure the performance of its own marketing campaigns and improve them over time.',
      url: 'https://values.snap.com/privacy/privacy-policy',
      marketPlace: 'https://hq1.appsflyer.com/partner-marketplace/partner/snapchat_int-ad_network',
    },
    {
      name: 'TikTok For Business',
      key: 'tiktokglobal_int',
      description: 'Enables Duet to measure the performance of its own marketing campaigns and improve them over time.',
      url: 'https://www.tiktok.com/legal/page/us/privacy-policy/en',
      marketPlace: 'https://hq1.appsflyer.com/partner-marketplace/partner/tiktokglobal_int-ad_network',
    },
    {
      name: 'Unity Ads',
      key: 'unityads_int',
      description: 'Enables Duet to measure the performance of its own marketing campaigns and improve them over time.',
      url: 'https://unity.com/legal/game-player-and-app-user-privacy-policy',
      marketPlace: 'https://hq1.appsflyer.com/partner-marketplace/partner/unityads_int-ad_network',
    },
    {
      name: 'X Ads',
      key: 'twitter_int',
      description: 'Enables Duet to measure the performance of its own marketing campaigns and improve them over time.',
      url: 'https://x.com/en/privacy',
      marketPlace: 'https://hq1.appsflyer.com/partner-marketplace/partner/twitter_int-ad_network',
    },
  ],
};
